import ReactDOM from 'react-dom'
// styles
import './index.scss'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
// components
import App from './App'
import Loading from './components/atoms/loading/loading'
// service Worker
import * as serviceWorker from './serviceWorker'
// Redux
import { Provider } from 'react-redux'
import createStore from './state/configureStore'
import { PersistGate } from 'redux-persist/integration/react'
import TagManager from 'react-gtm-module'

const { store, persistor } = createStore()

const tagManagerArgs = {
	gtmId: process.env.REACT_APP_GTM
}

TagManager.initialize(tagManagerArgs)

ReactDOM.render(
	<Provider store={store}>
		<PersistGate persistor={persistor} loading={<Loading />}>
			<App />
		</PersistGate>
	</Provider>,
	document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.register()
